/**
 * <mb-read-more>: texto inferior da listagem com "LEIA MAIS" (portado de pages/tag.js expandDescription).
 * O CSS deixa visíveis só os três primeiros parágrafos (e um título inicial); o clique revela o resto
 * e remove o botão, como no tema anterior. Com três blocos ou menos o botão nem aparece.
 */
class MbReadMore extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('[data-read-more-content]');
    this.button = this.querySelector('[data-read-more]');
    if (!this.content || !this.button) return;

    // metafield_tag envolve o rich text em .metafield-rich_text_field; sem ele, contamos os filhos diretos.
    const blocks = this.content.querySelector('.metafield-rich_text_field') || this.content;
    if (blocks.children.length <= 3) {
      this.button.hidden = true;
      return;
    }

    this.button.addEventListener('click', () => {
      this.content.classList.add('-active');
      this.button.remove();
    });
  }
}

if (!customElements.get('mb-read-more')) customElements.define('mb-read-more', MbReadMore);
